/* assets/favorites.js */
(function () {
  const STORAGE_KEY = 'ap_favorites_v1';           // session list of handles
  const LOGIN_FLAG  = 'ap_fav_last_logged_in';     // localStorage flag for last known login state
  const isLoggedIn = !!document.querySelector('.ap-fav-btn[data-customer-id]:not([data-customer-id=""])');

  // read a single customer id from any button (they all match if logged in)
  const customerId = (function(){
    const el = document.querySelector('.ap-fav-btn[data-customer-id]');
    const v = el ? el.dataset.customerId : '';
    return v && /^\d+$/.test(v) ? Number(v) : 0;
  })();

  // session store (guest)
  const store = {
    get() { try { return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]'); } catch { return []; } },
    set(arr) { try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(arr)); } catch(e) {} },
    clear() { try { sessionStorage.removeItem(STORAGE_KEY); } catch(e) {} }
  };

  // ==== Cloudflare Worker endpoint ====
  const API = {
    endpoint: 'https://ap-favorites.artpunch-net.workers.dev',
    async load() {
      if (!customerId) return store.get();
      const r = await fetch(`${this.endpoint}?customer_id=${customerId}`, { credentials: 'omit' });
      if (!r.ok) return store.get();
      const { favorites = [] } = await r.json();
      return Array.isArray(favorites) ? favorites : [];
    },
    async save(handles) {
      if (!customerId) return; // guests don't hit backend
      await fetch(`${this.endpoint}?customer_id=${customerId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ favorites: handles })
      }).catch(() => {});
    }
  };

  // ---- logout detection: if last state was logged-in and now it's not, clear session favorites
  (function handleLogoutClear(){
    const wasLoggedIn = localStorage.getItem(LOGIN_FLAG) === '1';
    const nowLoggedIn = isLoggedIn && customerId > 0;
    if (wasLoggedIn && !nowLoggedIn) {
      store.clear();
      document.dispatchEvent(new CustomEvent('ap:favorites:changed', { detail: [] }));
    }
    localStorage.setItem(LOGIN_FLAG, nowLoggedIn ? '1' : '0');
  })();

  async function init() {
    let favs = store.get();

    if (isLoggedIn && customerId) {
      try {
        const serverFavs = await API.load();
        const merged = Array.from(new Set([...serverFavs, ...favs]));
        store.set(merged);
        await API.save(merged); // persist to account
        favs = merged;
      } catch(e) {}
    }

    document.querySelectorAll('.ap-fav-btn').forEach(btn => {
      const handle = btn.dataset.handle;
      if (!handle) return;

      if (favs.includes(handle)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed','true');
      }

      btn.addEventListener('click', async () => {
        let list = store.get();
        const i = list.indexOf(handle);
        const active = i === -1;
        if (active) list.push(handle);
        else list.splice(i,1);
        store.set(list);

        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');

        if (isLoggedIn && customerId) {
          try { await API.save(list); } catch(e) {}
        }

        document.dispatchEvent(new CustomEvent('ap:favorites:changed', { detail: list }));
      });
    });
  }

  // expose for favorites page
  window.AP_FAVORITES = { get: () => store.get(), set: (arr) => store.set(arr) };

  document.addEventListener('DOMContentLoaded', init);
})();
